import { Box } from "@mui/material";
import { useRef } from "react";
import HeroSection from "../Hero/HeroSection";
import BusinessQuestionsSection from "../BusinessQuestionsSection/BusinessQuestionsSection";
import GrowthHelpSection from "../GrowthHelpSection/GrowthHelpSection";
import HighlightSection from "../HighlightSection/HighlightSection";
import ToolsStrategySection from "../ToolsStrategySection/ToolsStrategySection";
import AudienceSection from "../AudienceSection/AudienceSection";
import ParticipantSection from "../ParticipantSection/ParticipantSection";
import AboutSection from "../AboutSection/AboutSection";
import HowIWorkSection from "../HowIWorkSection/HowIWorkSection";
import CaseStudiesSection from "../CaseStudiesSection/CaseStudiesSection";
import IdealBusinessSection from "../IdealBusinessSection/IdealBusinessSection";
import RegistrationFormSection from "../RegistrationFormSection/RegistrationFormSection";

const HomePage = () => {
  const registrationRef = useRef(null);

  return (
    <Box>
      <HeroSection registrationRef={registrationRef} />
      <BusinessQuestionsSection />
      <GrowthHelpSection />
      <HighlightSection />
      <ToolsStrategySection />
      <AboutSection />
      <HowIWorkSection />
      <AudienceSection />
      <ParticipantSection />
      <CaseStudiesSection />
      <IdealBusinessSection />
      <RegistrationFormSection registrationRef={registrationRef} />
    </Box>
  );
};

export default HomePage;
